<template>
  <v-card
    class="ma-3"
    :class="{ 'elevation-0': $vuetify.breakpoint.smAndDown }"
  >
    <div v-for="(group, f) in list" :key="`group-${f}`">
      <div
        v-if="group.title"
        :class="`${$primaryColor} darken-2 white--text pa-2`"
        style="border-radius: 4px"
      >
        {{ group.title }}
      </div>

      <div>
        <v-list dense>
          <v-list-item-group>
            <v-list-item
              v-for="(item, j) in group.menus"
              :key="`item-${j}`"
              @click="
                $linkPath(
                  item.otherSystem,
                  item.itemPath,
                  item.programItemMenuID
                )
              "
            >
              <v-list-item-icon class="mr-1">
                <v-icon :color="$primaryColor" size="16"
                  >mdi-circle-outline</v-icon
                >
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title style="white-space: normal">
                  <template>
                    {{ item.name }}
                  </template>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    }
  }
}
</script>
